import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';

@Module({ dynamic: true, store, name: 'loadingControl', namespaced: true })
class LoadingControl extends VuexModule {
    // state
    /**
     * @State
     * ローディングフラグ
     */
    loading: boolean = false;

    loadCount: number = 0;

    /**
     * @Getter
     */
    get GET_LOADING() {
        return this.loading;
    }

    // Action
    /**
     * ローディングダイアログ開始
     */
    @Action({})
    public startLoading() {
        this.START_LOAD();
    }

    /**
     * ローディングダイアログ終了
     */
    @Action({})
    public endLoading() {
        this.END_LOAD();
    }

    // Mutation
    @Mutation
    private START_LOAD() {
        this.loadCount++;
        this.loading = true;
    }

    @Mutation
    private END_LOAD() {
        this.loadCount--;
        if (this.loadCount <= 0) {
            this.loading = false;
            this.loadCount = 0;
        }
    }

}

export const loadingControlModule = getModule(LoadingControl);
